import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["link"];
  static classes = ["current"];

  linkTargetConnected(link) {
    link.classList.toggle(this.currentClass, this.#isCurrent(link));
  }

  highlightCurrentTab() {
    this.linkTargets.forEach((link) => this.linkTargetConnected(link));
  }

  highlight(event) {
    this.linkTargets.forEach((link) =>
      link.classList.toggle(this.currentClass, link === event.currentTarget),
    );
  }

  #isCurrent(link) {
    return this.#section(link.pathname) === this.#section(window.location.pathname);
  }

  #section(path) {
    return path.split("/").filter(Boolean)[0] ?? "";
  }
}
